import request from './request';
const USER_BASE_URL = process.env.VUE_APP_USER_API || '';

/** iOS 下载地址配置（/user/v1.ChannelDownLink/getRxIosDownurl） */
export interface IosDownUrlData {
  /** 选中的下载地址；无可用地址时为空字符串 */
  downUrl: string;
  /** 选中的扫码地址 */
  scanDownUrl: string;
  /** 分享 key（盒子 type=3 / 热江 type=5） */
  shareKey: string;
}
/**
 * 获取热江 iOS 下载地址、扫码地址、分享 key
 */
export function getIosChannelConfig() {
  return request({
    baseURL: USER_BASE_URL,
    url: '/v1/ChannelDownLink/getRxIosDownurl',
    method: 'get',
  });
}
